import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
  Box,
  Autocomplete,
} from "@mui/material";
import "../../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation, useQuery } from "@apollo/client";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { AuthContext } from "../../../Context/AuthContext";
import { SelectWarehouse } from "../../Include/DynamicSelect";
import { SELECT_MATERIAL } from "../../../Schema/Material";
import ListPurchase from "../../ReqPurchase/ListPurchase";
import { CREATE_ADJUST_OUT } from "../../../Schema/Ajustment";
import SelectMaterailUnit from "../../ReqPurchase/SelectMaterailUnit";
import EmptyImge from "../../../Assets/empty-image.png";

export default function CreateAjustIn({ open, handleClose, setRefetch }) {
  //================ 
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [requiredField, setRequiredField] = useState(false);

  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [materialVal, setMaterialVal] = useState({ id: "", title: "" });

  const listAdjustData = {
    qty: 0,
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    key: Date.now() + Math.random(),
  };
  const [listData, setListData] = useState([listAdjustData]);

  const handleAdd = () => setListData([...listData, listAdjustData]);

  const handleRemove = (key) =>
    setListData(
      listData.filter((e) => {
        return e.key !== key;
      })
    );

  const handleUpdateList = (key, value, fieldName) => {
    const newData = listData?.map((d) => {
      if (value === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
        }
        if (key === d.key && fieldName === "qty") d.qty = 0;
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = value;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = value;
        if (key === d.key && fieldName === "qty") d.qty = value;
      }
      return d;
    });

    setListData(newData);
  };
  // console.log("listData:::", listData);

  const [listMaterialOptions, setMeterialOptions] = useState([]);
  const [checkShiftRefetch, setCheckShiftRefetch] = useState(false);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true,
      groupId: null,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      const Data = selectMaterial?.map((e) => {
        return {
          id: e?._id,
          title: e?.materialKhName,
        };
      });
      setMeterialOptions(Data);
    },
    onError: (error) => {
      // setLoading(true);
      console.log(error?.message);
    },
  });
  useEffect(() => {
    refetch();
  }, [checkShiftRefetch]);

  const [createAdjustOut] = useMutation(CREATE_ADJUST_OUT, {
    onCompleted: ({ createAdjustOut }) => {
      // console.log("createAdjustOut::", createAdjustOut)
      setLoading(false);
      if (createAdjustOut?.status) {
        setAlert(true, "success", createAdjustOut?.message);
        handleClose();
        resetForm();
        setRefetch();
        setWarehouseVal({ id: "", title: "" });
        setListData([listAdjustData]);
      } else {
        setAlert(true, "error", createAdjustOut?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
      console.log("error::", error);
    },
  });

  //formik
  const CheckValidation = Yup.object().shape({
    dateTime: Yup.date().required("ទាមទារ!"),
    remark: Yup.string(),
    warehouseId: Yup.string().required("ទាមទារ!"),
    reason: Yup.string().required("ទាមទារ!"),
  });
  
  const formik = useFormik({
    initialValues: {
      dateTime: new Date(),
      remark: "",
      warehouseId: "",
      reason: ""
    },
    
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            // console.log("element: ", elem)
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== ""
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequiredField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequiredField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      if (createStatus) {
        // console.log("createStatus,", createStatus)
        let listAdjOutToSubmit = listData.map((d) => {
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
          };
        });
        // console.log("values::",{
        //   ...values,
        //   adjustOutMaterial: listAdjOutToSubmit,
        // })
        setLoading(true);
        createAdjustOut({
          variables: {
            input: {
              ...values,
              adjustOutMaterial: listAdjOutToSubmit,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (warehouseVal?.id) {
      setFieldValue("warehouseId", warehouseVal?.id);
    }
  }, [warehouseVal?.id]);

  useEffect(() => {
    resetForm();
    setWarehouseVal({ id: "", title: "" });
    setListData([listAdjustData]);
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតការផ្ទេរចេញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              
              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំង</Typography>
                <SelectWarehouse
                  selectedVal={warehouseVal}
                  setSelectedVal={setWarehouseVal}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>
 
              <Grid item xs={4}>
                <Typography className='field-title'>កាលបរិច្ឆេទដកស្តុក</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd-MM-yyyy"  
                    value={values.dateTime ? new Date(values.dateTime) : null}
                    onChange={(newValue) => {
                      setFieldValue( "dateTime" , newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
                
                {!!errors.dateTime && touched.dateTime && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.dateTime}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className='field-title'>មូលហេតុ</Typography>
                <FormControl className="search-field" fullWidth size="small">
                  <Select
                    value={values?.reason}
                    onChange={(e) => setFieldValue("reason", e.target.value)}
                  >
                    <MenuItem value="lose">បាត់</MenuItem>
                    <MenuItem value="broken">ខូច</MenuItem>
                    <MenuItem value="to_use">ប្រើប្រាស់</MenuItem>
                    <MenuItem value="excess">លើស</MenuItem>
                  </Select> 
                </FormControl>
                
                {!!errors.reason && touched.reason && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.reason}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
                  <Stack direction="row" spacing={1}>
                    <Typography
                      className="field-title-list"
                      sx={{ width: "10%" }}
                    >
                      រូបភាព
                    </Typography>
                    <Typography
                      className="field-title-list"
                      sx={{ width: "40%" }}
                    >
                      ឈ្មោះសម្ភារៈ
                    </Typography>
                    <Typography
                      className="field-title-list"
                      sx={{ width: "20%" }}
                    >
                      ឯកតា
                    </Typography>
                    <Typography
                      className="field-title-list"
                      sx={{ width: "20%" }}
                    >
                      ចំនួន
                    </Typography>
                    <Stack
                      width="10%"
                      // textAlign={`right`}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box>
                        <IconButton
                          onClick={handleAdd}
                          // disabled={disabled}
                          sx={{ width: "25px", height: "25px" }}
                        >
                          <AddCircleIcon sx={{ color: "#2e3192" }} />
                        </IconButton>
                      </Box>
                    </Stack>
                  </Stack>
                  {listData?.map((e, index) => {
                    return (
                      <Stack direction="row" spacing={1} key={index}>
                        <Stack width="10%">
                          <img
                            style={{
                              borderRadius: "10px",
                              objectFit: "cover",
                              width: "80%",
                            }}
                            src={
                              e?.listMaterialUnitId?.imageSrc
                                ? e?.listMaterialUnitId?.imageSrc
                                : EmptyImge
                            }
                          />
                        </Stack>
                        <Stack width={`40%`}>
                          <Autocomplete
                            value={e.materialId}
                            options={listMaterialOptions}
                            onChange={(event, val) => {
                              setCheckShiftRefetch(true);
                              handleUpdateList(e.key, val, "materialId");
                            }}
                            getOptionLabel={(option) =>
                              option?.title === undefined
                                ? "ជ្រើសរើស"
                                : option?.title
                            }
                            isOptionEqualToValue={(option, value) =>
                              option?.value === value?.value
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                placeholder={"ជ្រើសរើស"}
                                error={
                                  (requiredField &&
                                    e?.materialId?.id === undefined) ||
                                  (requiredField && e?.materialId?.id === "")
                                    ? true
                                    : false
                                }
                              />
                            )}
                          />
                        </Stack>
                        <Stack width={`20%`}>
                          <SelectMaterailUnit
                            eachList={e}
                            handleUpdateValue={handleUpdateList}
                            requiredField={requiredField}
                          />
                        </Stack>
                        <Stack width={`20%`}>
                          <TextField
                            value={e?.qty}
                            onChange={(val) =>
                              handleUpdateList(e.key, val.target.value, "qty")
                            }
                            size="small"
                            inputProps={{ min: 0 }}
                            type="number"
                            onFocus={(e) => e?.target?.select()}
                            error={
                              (requiredField && e?.qty === 0) ||
                              (requiredField && e?.qty < 0)
                            }
                          />
                        </Stack>
                        <Stack
                          width="10%"
                          direction="column"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <IconButton
                            sx={{ width: "25px", height: "25px" }}
                            onClick={(event) => handleRemove(e.key)}
                            // disabled={disabled}
                          >
                            <RemoveCircleIcon sx={{ color: "red" }} />
                          </IconButton>
                        </Stack>
                      </Stack>
                    );
                  })}
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  កំពុងដំណើរការ...
                </Button>
              ) : (
                <Button className="btn-create" fullWidth onClick={handleSubmit}>
                  បង្កើត
                </Button>
              )}
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
